import { ReportType } from "libs/report-enum";

const REPORT_IDS = {
  development: {
    sales: "febd529e-3751-4ac9-a58f-fbe44ea89bf3",
    productInventory: "a1cb6b88-8b32-4d15-b803-9964c7721e31",
    transaction: "521bab59-87e5-4a14-9e4b-af008a564b71",
  },
  staging: {
    sales: "c36486c9-492a-4cfa-bb70-405d92ce5bbd",
    productInventory: "32858156-eb26-423d-89a0-f52875182bdc",
    transaction: "02d5da04-3837-4cbd-826e-605b41ee297c",
  },
  production: {
    sales: "c36486c9-492a-4cfa-bb70-405d92ce5bbd",
    productInventory: "32858156-eb26-423d-89a0-f52875182bdc",
    transaction: "02d5da04-3837-4cbd-826e-605b41ee297c",
  },
};

const env =
  process.env.NODE_ENV.toString().toLowerCase() as keyof typeof REPORT_IDS;

export const getReportId = (report: ReportType): string => {
  switch (report) {
    case ReportType.Sales:
      return REPORT_IDS[env].sales;
    case ReportType.ProductInventory:
      return REPORT_IDS[env].productInventory;
    case ReportType.Transaction:
      return REPORT_IDS[env].transaction;
    default:
      return "";
  }
};
